import {
  Body as DSBody,
  axiomTokens,
  MaterialUICore,
  Card as DSCard,
  Button as DSButton,
  DialogHeader as DSDialogHeader,
  DialogContent as DSDialogContent,
} from '@iclinic/design-system';

const { styled } = MaterialUICore;

const { font, color, spacing, shadow, border } = axiomTokens;

export const CardContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  gap: spacing[4],

  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
  },
}));

export const Card = styled(DSCard)({
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  color: color.highlight.blue[1],
  backgroundColor: color.interactive.subtle.default,
  padding: spacing[4],
  paddingRight: spacing[6],
  gap: spacing[4],
  textAlign: 'start',
  fontFamily: font.family.base,
  fontWeight: font.weight.bold,
  fontSize: font.size.xs,
  boxShadow: shadow.level[2],
  borderRadius: border.radius.md,
  width: '100%',
});

export const DialogHeader = styled(DSDialogHeader)({
  padding: `${spacing[4]} ${spacing[4]}`,
});

export const DialogContent = styled(DSDialogContent)({
  paddingBottom: 0,
});

export const Body = styled(DSBody)(() => ({
  lineHeight: '1.5',
  fontWeight: font.weight.medium,
  marginTop: spacing[2],
}));

export const IconWrapper = styled('div')({
  textAlign: 'start',
  height: spacing[8],
  width: 'auto',

  '& svg': {
    height: '100%',
    fill: 'currentColor',
  },
});

export const FieldsWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '2fr 2fr',
  gap: spacing[4],
});

export const CepWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '3fr 1fr',
  gap: spacing[4],
});

export const CheckboxWrapper = styled('div')({
  display: 'grid',
  gridTemplateColumns: '4fr',
});

export const CepHelper = styled('a')({
  fontSize: font.size.xxs,
  textDecoration: 'none',
  fontWeight: font.weight.medium,
  letterSpacing: '0.72px',
  alignSelf: 'center',
  cursor: 'pointer',
  color: color.typeface.feedback.info,
  '&:hover': {
    textDecoration: 'none',
  },
});

export const ButtonStyled = styled(DSButton)({
  color: color.typeface.pure,
});
